'use strict';

var footInchFormatter = require('footinch').format;
var formatter = footInchFormatter.FT.to.FT.IN.FRAC(64, [' ', '']);

module.exports = function (value) {
    var formatted = formatter(value),
        parts = formatted.split(' '),
        prefix = value < 0 ? '-' : '';

    var inch = parseInt(parts[0]) * 12 + parseInt(parts[1]);

    if (inch === 0 && parts[2]) return '' + prefix + parts[2];
    if (inch === 0) return '0';

    if (inch < 0 && prefix === '-') prefix = '';

    if (!parts[2]) return '' + prefix + inch;
    if (parts[2] === '1/1') return '' + prefix + (inch + 1);

    return '' + prefix + inch + ' ' + parts[2];
};


//////////////////
// WEBPACK FOOTER
// ./server/models/inch-pound/lib/fractional.js
// module id = 495
// module chunks = 0